import { useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";

const Slideshow = ({
  prezzoFissoIndex = 0,
  mediaIdIndex = 0,
  slideList,
  containerClass,
  itemClass,
  dotListClass,
  swipeableProp,
  draggableProp,
  showDotsProp,
  infiniteProp,
  autoPlayProp,
  autoPlaySpeedProp,
  responsiveProp,
  arrowsProp,
  partialVisibleProp,
  customLeftArrowProp,
  customRightArrowProp,
  removeArrowOnDeviceTypeProp,
  deviceTypeProp,
  transitionDurationProp = "500",
}) => {
  const CarouselRef = useRef();
  useEffect(() => {
    console.log("Slideshow rerender", CarouselRef);

    if (document.getElementsByClassName(
        "mediagalleryid-" + mediaIdIndex
      )[0] !== undefined) {
      let imageitem = document.getElementsByClassName(
        "mediagalleryid-" + mediaIdIndex
      )[0],
      parentpositionslide = imageitem.parentNode.getAttribute('data-index');
      console.log("Slideshow itempar: ", parentpositionslide);
      if (parentpositionslide !== undefined) {
        CarouselRef.current.goToSlide(Number(parentpositionslide));
      } else {
        CarouselRef.current.goToSlide(0);
      }
    } else {
      CarouselRef.current.goToSlide(0);
    }
  }, [mediaIdIndex]);

  return (
    <Carousel
      ref={CarouselRef}
      swipeable={swipeableProp}
      draggable={draggableProp}
      showDots={showDotsProp}
      responsive={responsiveProp}
      ssr={true}
      arrows={arrowsProp ? arrowsProp : false}
      infinite={infiniteProp}
      centerMode={false}
      additionalTransfrom={0}
      autoPlay={autoPlayProp}
      autoPlaySpeed={autoPlaySpeedProp ? autoPlaySpeedProp : 1000}
      keyBoardControl={false}
      transitionDuration={transitionDurationProp}
      minimumTouchDrag={40}
      containerClass={containerClass ? containerClass : "carousel-container"}
      customLeftArrow={customLeftArrowProp ? customLeftArrowProp : null}
      customRightArrow={customRightArrowProp ? customRightArrowProp : null}
      removeArrowOnDeviceType={
        removeArrowOnDeviceTypeProp ? removeArrowOnDeviceTypeProp : ""
      }
      partialVisible={partialVisibleProp ? partialVisibleProp : false}
      deviceType={deviceTypeProp ? deviceTypeProp : "desktop"}
      dotListClass={dotListClass ? dotListClass : ""}
      itemClass={itemClass ? itemClass : "custom-dot-list-style"}
      customTransition="transform 300ms ease-in-out"
    >
      {slideList}
    </Carousel>
  );
};

export default Slideshow;
